import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "../../data";

export const Statement = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative h-[70vh] md:h-[92vh] overflow-hidden" data-testid="statement-section">
      <motion.img
        style={{ y, scale: 1.2 }}
        src={IMAGES.statement}
        alt="NK Bridal brides"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-ink/35" />
      <div className="relative h-full mx-auto max-w-[1600px] px-6 md:px-12 flex flex-col justify-end pb-16 md:pb-24">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="text-xs uppercase tracking-[0.35em] text-ivory/70 mb-5">Side by side</p>
          <h2 className="font-serif font-light text-ivory text-5xl md:text-8xl leading-[0.9] tracking-tight max-w-4xl">
            Every bride, her <span className="italic">own</span> story
          </h2>
        </motion.div>
      </div>
    </section>
  );
};
